<template>
    <div>
        <div>
            <b-card no-body>
                <b-card-body>
                    <div>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <app-tabela
                            :itens="metas"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false">
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <btn-inserir-meta
                                    :acao="acao"
                                    class="mr-2"
                                    :dataServicos="dataServicos"
                                    @atualizarLista="atualizarLista()">
                                </btn-inserir-meta>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                                <btn-excluir-meta
                                    :acao="acao"
                                    class="text-danger float-left mr-1"
                                    :meta="data"
                                    :dataServicos="dataServicos"
                                    @atualizarLista="atualizarLista()"
                                ></btn-excluir-meta>
                        </template>
                        </app-tabela>
                    </div>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>
    
<script>
import BtnInserirMeta from './BtnInserirMeta.vue'
import BtnExcluirMeta from './BtnExcluirMeta.vue'

export default {
    components: {
        BtnInserirMeta,
        BtnExcluirMeta        
    },

    props: {
        dataServicos: {
            type: Object
        },
        acao: {
            type: Object,
            default: () => ({})
        },
        acaoMetas : {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            erros: [],
            metas: [],
            itensPorPagina: 5,
            campos: [
                {
                    key: 'tipoInstrumentoDescricao',
                    label: 'Tipo Instrumento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'quantidadeHorasTotais',
                    label: 'Quantidade Horas Totais',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'numeroPessoasFisicas',
                    label: 'Número de pessoas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'pequenosNegociosInscritos',
                    label: 'Pequenos Negócios Inscritos ',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterMetasPorAcao(this.acao.acaoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.metas = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.metas = this.acaoMetas
    }
}
</script>
